export const getTimeZone = (local: string) => {
  try {
    if (!local) local = 'en-US';
    // 创建一个 DateTimeFormat 实例，不指定时区
    const formatLocal = local.replace(/_/g, '-');
    const formatter = new Intl.DateTimeFormat(formatLocal);
    const options = formatter.resolvedOptions();
    return options.timeZone;
  } catch (error) {
    // 捕获并处理错误，例如返回默认值或抛出自定义错误
    console.error(`Invalid locale provided: ${local}`);
    throw error;
  }
};
